// 排序
export const moveZero = (arr, inverse = false) => {
  const valueArr = [];
  const undeArr = [];
  arr?.forEach((item) => {
    if (
      (Array.isArray(item?.data) && item?.data[1] && !isNaN(item?.data[1])) ||
      (item?.data && !isNaN(item?.data))
    ) {
      valueArr.push(item);
    } else {
      undeArr.push(item);
    }
  });
  const sortArr = valueArr.sort((a, b) => {
    if (typeof a.data === 'number' || typeof a.data === 'string') {
      const aVal = parseFloat(a?.data);
      const bVal = parseFloat(b?.data);
      return inverse ? aVal - bVal : bVal - aVal;
    }
    const aVal = parseFloat(a?.data[1]);
    const bVal = parseFloat(b?.data[1]);
    return inverse ? aVal - bVal : bVal - aVal;
  });
  return [...sortArr, ...undeArr];
};

export const lineTooltipFormatter = (
  _param: string | any[],
  letTitle,
  rightTitle,
  valueFormatFun,
  isShowMarket = true,
) => {
  const param = _param; // moveZero(_param);  要区别排名的话是顺序，其他是倒序
  let allContent = '';
  const contentArr = [];
  const returnStr = `
        <div style="font-size:12px;margin-bottom:4px;text-align: left;">
            <div style="color:#000000;opacity:0.45;text-align: left;margin-right:20px;display:inline-block;">
                ${letTitle}
            </div>
            <div style="color:#000000;opacity:0.45;float:right;display:inline-block;">
                ${rightTitle}
            </div>
        </div>`;
  for (let i = 0; i < param?.length; i++) {
    const nameVal = param[i]?.seriesName || '';
    let value = '';
    if (typeof param[i].value === 'object') {
      value = param[i].value[1];
    } else {
      value = param[i].value;
    }
    const item = {
      market: `<span style="display:inline-block;margin-right:2px;border-radius:10px;width:8px;height:8px;background-color:${param[i].color};"></span>`,
      name: `<span style="color:#000000;opacity:0.65;font-size:12px;">${nameVal}</span>`,
      value: `<span style="color:#000000;font-weight:bold;opacity:1;">${
        valueFormatFun ? valueFormatFun(value) : value
      }</span>`,
    };
    contentArr?.push(item);
  }

  const getName = contentArr?.map((v) => {
    return `<div>${isShowMarket ? v?.market : ''} ${v?.name}</div>`;
  });
  const getValue = contentArr?.map((v) => {
    return `<div>${v?.value}</div>`;
  });

  const bodyContent = `
    <div>
        <div style="display: inline-block;float:left;margin-right:20px;text-align: left;">
            ${getName?.join('')}
        </div>
        <div style="display: inline-block;float:right;text-align:right;">
            ${getValue?.join('')}
        </div>
    </div>`;
  // opacity:0.95;
  allContent = `
        <div style="background-color: #fffffff;margin-left:2px;margin-top:-4px;margin-bottom:-4px;font-size:12px;">
            ${returnStr} ${bodyContent}
        </div>`;
  return allContent;
};

export const gameIDRex = (id: string) => {
  if (typeof id === 'string') {
    return id.replace(/[^a-z0-9]+/gi, '');
  }
  return id;
};

// 直接加%  正是正 负是负   留存左边
export const toFixed0 = (value: any, point = 2) => {
  let _newVal: string | number = parseFloat(value);
  if (value == '' || isNaN(_newVal)) {
    return '-';
  }
  _newVal = _newVal.toFixed(point);
  return `${_newVal}%`;
};

export const PLATFORM: { [key: string]: any } = {
  appnnie: 'data.ai',
  appannie: 'data.ai',
  hatchet: 'Hatchet',
  databrain: 'DataBrain',
  ogdb: 'DataBrain',
  mscience: 'M Science',
  newzoo: 'Newzoo',
  sensortower: 'Sensor Tower',
  npdL: 'NPD',
};

export const getDeviceName = (str: string) => {
  switch (str) {
    case 'playstation store':
      return 'PlayStation';
    case 'nintendo eshop':
      return 'Nintendo';
    case 'microsoft store':
      return 'Xbox';
    case 'pc':
      return 'PC';
    default:
      return str;
  }
};

export const getIsPercentMetric = (str: string) => {
  switch (str) {
    case 'churn':
      return true;
    default:
      return false;
  }
};
